import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase";

export const adminGetAuthUser = httpsCallable(functions, "adminGetAuthUser");
export const adminRefreshUserClaims = httpsCallable(functions, "adminRefreshUserClaims");
export const adminDisableAuthUser = httpsCallable(functions, "adminDisableAuthUser");
export const adminGeneratePasswordResetLink = httpsCallable(functions, "adminGeneratePasswordResetLink");
export const adminEnsureAuthUser = httpsCallable(functions, "adminEnsureAuthUser");
export const adminGetCollectionCounts = httpsCallable(functions, "adminGetCollectionCounts");
export const adminQueryAuditLogs = httpsCallable(functions, "adminQueryAuditLogs");
export const listFirestoreCollections = httpsCallable(functions, "listFirestoreCollections");
export const queryCustomerDocuments = httpsCallable(functions, "queryCustomerDocuments");
export const getCustomerCollectionCount = httpsCallable(functions, "getCustomerCollectionCount");
